module.exports = __webpack_public_path__ + "static/media/Slika1.dc48a798.png";